var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.375C9.82995 9.375 11.7188 7.55616 11.7188 5.3125C11.7188 3.06884 9.82995 1.25 7.5 1.25C5.17005 1.25 3.28125 3.06884 3.28125 5.3125C3.28125 7.55616 5.17005 9.375 7.5 9.375Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86875 9.75666C10.075 9.65041 10.3125 9.80666 10.3125 10.0379V13.0692C10.3125 13.6317 9.91875 13.9067 9.43125 13.6754L7.75625 12.8817C7.6125 12.8192 7.3875 12.8192 7.24375 12.8817L5.56875 13.6754C5.08125 13.9004 4.6875 13.6254 4.6875 13.0629L4.7 10.0379C4.7 9.80666 4.94375 9.65666 5.14375 9.75666C5.85 10.1129 6.65 10.3129 7.5 10.3129C8.35 10.3129 9.15625 10.1129 9.86875 9.75666Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.ad263c5f8ea870deba40a79330e45b9f.svg";
export { ForwardRef as ReactComponent };